import { render, staticRenderFns } from "./VerCaixasGoogleMaps.vue?vue&type=template&id=34587fe4&scoped=true&"
import script from "./VerCaixasGoogleMaps.vue?vue&type=script&lang=js&"
export * from "./VerCaixasGoogleMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34587fe4",
  null
  
)

export default component.exports